import React from 'react';
import styled from 'styled-components';
import Highlighter from 'react-highlight-words';
import TextCropper from '@omilia/text-cropper';
import { colors } from '@omilia/theme';
import Tooltip from '@omilia/tooltip';
import Icon from '@omilia/icon';

const SDropdownItem = styled.div<{ isArchived: boolean }>`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 5px 16px;
  width: 100%;

  cursor: ${({ isArchived }) => isArchived && 'not-allowed'};
  text-decoration: ${({ isArchived }) => isArchived && 'line-through'};

  &:hover {
    background-color: ${colors.COLOR_BLUE_600};
    cursor: ${({ isArchived }) => (isArchived ? 'not-allowed' : 'pointer')};
  }
`;

const STextCropper = styled(TextCropper)<{ isArchived: boolean }>`
  span {
    color: ${({ isArchived }) =>
      isArchived ? colors.COLOR_GREY_500 : colors.COLOR_GREY_1000};
    font-weight: 400;
    line-height: 26px;
    text-transform: none;
  }

  a {
    color: ${colors.COLOR_GREY_1000};
  }
`;

interface Props {
  item: {
    name: string;
    archived: boolean;
  };
  searchTerm?: string;
  isArchived: boolean;
}

const FieldDropdownItem = React.forwardRef<HTMLDivElement, Props>(
  ({ item, searchTerm = '', ...restProps }: Props, ref) => {
    const name = item?.name ?? '';
    const { archived } = item;

    return (
      <SDropdownItem ref={ref} isArchived={archived} {...restProps}>
        <STextCropper key={name} isArchived={archived} text={name}>
          <Highlighter
            autoEscape
            highlightStyle={{
              backgroundColor: 'transparent',
              border: 'none',
              color: colors.COLOR_GREY_700,
              fontWeight: 500,
            }}
            searchWords={[searchTerm]}
            textToHighlight={name}
          />
        </STextCropper>
        {archived && (
          <Tooltip content="Archived Intent!" placement="right">
            <Icon
              data-test="error-icon"
              glyph="notification-error"
              primaryColor={colors.COLOR_RED_600}
              size="12"
            />
          </Tooltip>
        )}
      </SDropdownItem>
    );
  },
);

export default FieldDropdownItem;
